import config from '../config';
import { EMPTY_DOCX_BASE64 } from './emptyDocxBase64';
import fileService from '../services/fileService';

const DOCX_MIME =
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document';

export function getDocsBaseUrl(): string {
  return (config.docs?.baseUrl || 'https://docs.cynayd.com').replace(/\/$/, '');
}

export function isDocxFile(nameOrExt?: string | null, mimeType?: string | null): boolean {
  const name = (nameOrExt || '').toLowerCase();
  if (name.endsWith('.docx') || name === 'docx') return true;
  if (mimeType === DOCX_MIME) return true;
  return false;
}

export function buildEditInDocsUrl(driveFileId: string): string {
  const base = getDocsBaseUrl();
  return `${base}/open/drive?driveFileId=${encodeURIComponent(driveFileId)}`;
}

export function openFileInDocs(driveFileId: string): void {
  window.open(buildEditInDocsUrl(driveFileId), '_blank', 'noopener,noreferrer');
}

function base64ToUint8Array(base64: string): Uint8Array {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
}

export function createEmptyDocxFile(fileName = 'Untitled Document.docx'): File {
  const bytes = base64ToUint8Array(EMPTY_DOCX_BASE64);
  return new File([bytes], fileName, { type: DOCX_MIME });
}

/**
 * Upload an empty .docx into the current folder and open it in Docs.
 */
export async function createAndOpenNewDocument(folderId?: string | null): Promise<string> {
  const stamp = new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-');
  const file = createEmptyDocxFile(`Untitled Document ${stamp}.docx`);
  const uploaded = await fileService.uploadFile(file, {
    folderId: folderId && folderId !== 'root' ? folderId : undefined,
  });
  const raw = uploaded as { id?: string; file?: { id?: string }; data?: { id?: string; file?: { id?: string } } };
  const id = raw?.file?.id || raw?.id || raw?.data?.file?.id || raw?.data?.id;
  if (!id) {
    throw new Error('Upload succeeded but no file id was returned');
  }
  openFileInDocs(id);
  return id;
}
